var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExitMobile = function SvgExitMobile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.228 5.228A.778.778 0 0 1 5.778 5h3.555a1 1 0 1 0 0-2H5.778A2.778 2.778 0 0 0 3 5.778V18.22A2.778 2.778 0 0 0 5.778 21h3.555a1 1 0 0 0 0-2H5.778A.778.778 0 0 1 5 18.22V5.778c0-.207.082-.404.228-.55zm9.62 1.62a1 1 0 0 1 1.414 0l4.439 4.44a1.02 1.02 0 0 1 .186.252.997.997 0 0 1-.191 1.178l-4.434 4.433a1 1 0 0 1-1.414-1.414L17.585 13H9.334a1 1 0 1 1 0-2h8.251l-2.737-2.737a1 1 0 0 1 0-1.414z",
    fill: "#606060"
  })));
};
export default SvgExitMobile;